import { StateCreator } from "zustand";
import { GlobalState } from "../globalStore";
import type { TargetOutput } from "@/core/fastapiClient/sdk";

export interface TargetState {
  data: TargetOutput[];
  isLoading: boolean;
  error: string | null;
}

export interface TargetSlice {
  targets: TargetState;
  setTargets: (targets: TargetOutput[]) => void;
  setTargetsLoading: () => void;
  setTargetsError: (error: string) => void;
  resetTargets: () => void;
  // Initial state loading
  initFetchedTargets: boolean;
  setInitFetchedTargets: (fetched: boolean) => void;
}

export const createTargetSlice: StateCreator<
  GlobalState,
  [],
  [],
  TargetSlice
> = (set) => ({
  //* Basic state manipulation
  targets: {
    data: [],
    isLoading: false,
    error: null,
  },

  setTargets: (data) =>
    set({
      targets: { data, isLoading: false, error: null },
    }), // Note the differnce:// Direct assignment to the state object, completely replacing it

  setTargetsLoading: () =>
    set((state) => ({
      targets: { ...state.targets, isLoading: true, error: null },
    })), // Note the differnce:// Using a function to update the state object, merging the new data with the existing state ... because loading state needs to know about thre previous state!

  setTargetsError: (error) =>
    set((state) => ({
      targets: { ...state.targets, error, isLoading: false },
    })),

  resetTargets: () =>
    set({
      targets: { data: [], isLoading: false, error: null },
    }),
  // Initial state loading
  initFetchedTargets: false,
  setInitFetchedTargets: (fetched) => set({ initFetchedTargets: fetched }),
});
